import Box from "@mui/material/Box"
import Link from "@mui/material/Link"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"
import { Link as RouterLink } from "react-router-dom"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { adminLiquidEmptyStateSx } from "../adminStyles"
import AdminLiquidSurface from "./AdminLiquidSurface"

export default function AdminDashboardPanel({
  title,
  subtitle,
  viewAllTo,
  viewAllLabel = "View all",
  columns,
  rows,
  emptyMessage = "No records yet.",
  renderRow,
}) {
  return (
    <AdminLiquidSurface
      variant="card"
      sx={{
        p: { xs: 2, sm: 2.5 },
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Row
        sx={{
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 1.5,
          mb: 2,
        }}
      >
        <Column gap={0.25}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, color: "colors.gray800" }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Column>
        {viewAllTo ? (
          <Link
            component={RouterLink}
            to={viewAllTo}
            underline="hover"
            sx={{ fontWeight: 600, fontSize: 14, whiteSpace: "nowrap" }}
          >
            {viewAllLabel}
          </Link>
        ) : null}
      </Row>

      {rows?.length ? (
        <Box sx={{ overflowX: "auto", mx: -0.5 }}>
          <Table size="small" sx={{ minWidth: 320 }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || "left"}
                    sx={{
                      fontWeight: 600,
                      color: "colors.gray600",
                      borderBottomColor: "colors.gray200",
                      py: 1.25,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{rows.map(renderRow)}</TableBody>
          </Table>
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 180,
            px: 2,
            ...adminLiquidEmptyStateSx,
          }}
        >
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {emptyMessage}
          </Typography>
        </Box>
      )}
    </AdminLiquidSurface>
  )
}

AdminDashboardPanel.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  viewAllTo: PropTypes.string,
  viewAllLabel: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(["left", "right", "center"]),
    })
  ).isRequired,
  rows: PropTypes.array,
  emptyMessage: PropTypes.string,
  renderRow: PropTypes.func.isRequired,
}
